import dynamic from 'next/dynamic'
import React from 'react'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import AppQRModalLegacy from './app-qr-modal-legacy'

import type { AppQRModalProps } from './app-qr-modal-legacy'

// Dynamically imported so the web-ui/Panda tree stays off the legacy bundle — this modal is reachable
// from always-loaded surfaces (PDP/QATC, header, collection banner).
const AppQRModalDS = dynamic(() => import(/* webpackChunkName: "app-qr-modal-ds" */ './app-qr-modal-ds'))

function AppQRModal(props: AppQRModalProps) {
  if (shouldUseDesignSystem()) {
    return <AppQRModalDS {...props} />
  }
  return <AppQRModalLegacy {...props} />
}

export type { AppQRModalProps }
export default AppQRModal
